<template>
  <div class="app" :class="{ dark: theme === 'dark' }">
    <!-- Global sayfa geçişi yükleme çubuğu -->
    <GlobalLoading />

    <!-- Layout wrapper -->
    <component :is="layoutComponent" v-if="layoutComponent">
      <RouterView />
    </component>

    <!-- No layout (404 etc.) -->
    <RouterView v-if="!layoutComponent" />

    <!-- Global toast notifications -->
    <Toast />

    <!-- Global onay (confirm) modalı -->
    <ConfirmDialog />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import GlobalLoading from '@/components/common/GlobalLoading.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'
import DashboardLayout from '@/layouts/DashboardLayout.vue'
import PortalLayout from '@/layouts/PortalLayout.vue'
import { useUIStore } from '@/stores/ui.store'

const route = useRoute()
const uiStore = useUIStore()

const theme = computed(() => uiStore.theme)

const layoutComponent = computed(() => {
  // Check current route AND parent routes for layout meta
  const layout = route.matched.reduce<string | undefined>(
    (acc, record) => (record.meta.layout as string) || acc,
    undefined
  )

  switch (layout) {
    case 'auth':
      return AuthLayout
    case 'dashboard':
      return DashboardLayout
    case 'portal':
      return PortalLayout
    default:
      return null
  }
})
</script>

<style scoped>
.app {
  min-height: 100vh;
}
</style>
